export default __webpack_public_path__ + "static/media/like_active_btn.34ce224a.svg";